import { useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { getCampaigns } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";

import { LAUNCH_OS_ICON } from "@/brand";
export const SocialMediaCampaigns = ({ name = "" }) => {
  const [socialMediaCampaignList, setSocialMediaCampaignList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // get the socialMediaCampaignList from the server
  const loadSocialMediaCampaigns = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "social" });
    // const response = await getCampaigns({ token, type: "socialMediaCampaign" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((socialMediaCampaign: any) => {
          return {
            id: socialMediaCampaign.id,
            label: socialMediaCampaign.name,
            caption: `Last Updated: ${moment(socialMediaCampaign.updatedAt).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setSocialMediaCampaignList(seqs);
    }
    setIsLoading(false);
  };

  // load the socialMediaCampaignList when the page loads
  useEffect(() => {
    loadSocialMediaCampaigns();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Link to="/launchpad/social" className="justify-end">
            <Button label="+ Create a Social Media Campaign" type={ButtonTypes.OUTLINED} />
          </Link>
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(socialMediaCampaignList.length) && (
          <EmptyState
            title="No Social Media Campaigns Yet"
            description="Get started by creating a new socialship site."
            showImage={false}
          >
            <Link to="/launchpad/social">
              <Button label="Create a Social Media Campaign" type={ButtonTypes.DEFAULT} />
            </Link>
          </EmptyState>
        )}
        {!isLoading && Boolean(socialMediaCampaignList.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {socialMediaCampaignList.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/social/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
